import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import { LOCALE } from "../config/locale";

const resources = {
  "en-US": { translation: en },
  en: { translation: en },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: LOCALE,
    fallbackLng: LOCALE,
    supportedLngs: [LOCALE, "en"],
    interpolation: { escapeValue: false },
    // Detection disabled — locale is hardcoded to en-US.
    detection: { order: [], caches: [] },
  });
}

export default i18n;
